import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import API from '../api/axios';
import Footer from '../components/Footer';
import '../style/LandPage.css';
import logoImg from '../assests/InvoiceLOGO.jpeg';

export default function Land() {
  const { user } = useContext(AuthContext);
  const { darkMode } = useTheme();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await API.get('/products');
        setProducts(res.data);
      } catch (err) {
        console.error("Failed to fetch products", err);
      }
    };
    fetchProducts();
  }, []);

  // const handleProductClick = (productId) => {
  //   if (user) {
  //     navigate(`/product/${productId}`);
  //   } else {
  //     setShowModal(true);
  //   }
  // };
  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  }; // by rajan - products won't check for users signin 

  return (
    <div className={`land-page-target ${darkMode ? 'dark' : 'light'}`}>
      <div className="land-content-wrapper">

        {/* 1. 🤖 Hero Banner Section */}
        {/* 1. 🤖 Hero Banner Section */}
        <section className="target-hero-card">
          <div className="hero-left-content">
            <span className="hero-pill-badge">Official Store • SS Robotics</span>
            <h1 className="hero-main-title">
              High Performance <span>Robotics & Industrial</span> Components
            </h1>
            <p className="hero-main-sub">
              Discover premium sensors, microcontroller modules, and DIY engineering tools delivered directly to your doorstep.
            </p>
            {/* <button
              className="hero-cta-btn"
              onClick={() => navigate(user ? '/' : '/register')}
            >
              Explore Full Catalog ➔
            </button> */}

            {/*  niche prod section me le jane ke liye - by rajan */}
            <button
              className="hero-cta-btn"
              onClick={() => {
                const productSection = document.querySelector('.products-carousel-wrapper');
                if (productSection) {
                  productSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Explore Full Catalog ➔
            </button>


          </div>

          {/* <div className="hero-right-graphic">
            <div style={{
              background: darkMode ? '#1E293B' : '#FFFFFF',
              padding: '2rem',
              borderRadius: '24px',
              boxShadow: '0 12px 35px rgba(0,0,0,0.1)',
              border: '1px solid rgba(0, 123, 255, 0.2)',
              textAlign: 'center',
              maxWidth: '300px'
            }}>
              {/* 🖼️ Official Brand Logo Image */}
          {/* <img
                src={logoImg}
                alt="SS Robotics Logo"
                style={{
                  width: '110px',
                  height: '110px',
                  objectFit: 'cover',
                  borderRadius: '16px',
                  marginBottom: '0.8rem',
                  boxShadow: '0 4px 14px rgba(0,0,0,0.08)'
                }}
              />
              <h3 style={{ margin: '0 0 0.3rem', color: '#007BFF', fontSize: '1.3rem', fontWeight: '800' }}>
                SS Robotics
              </h3>
              <p style={{ margin: 0, opacity: 0.85, fontSize: '0.85rem', lineHeight: '1.4' }}>
                Precision Components & Rapid Delivery
              </p>
            </div>
          </div> */}
          <div className="hero-right-graphic">
            <img
              src={logoImg}
              alt="SS Robotics Brand Logo"
              style={{
                width: '100%',
                maxWidth: '340px',
                height: '350px',
                objectFit: 'contain',
                borderRadius: '24px',
                padding: '1.2rem',
                backgroundColor: darkMode ? '#1E293B' : '#FFFFFF',
                boxShadow: '0 10px 30px rgba(0, 123, 255, 0.15)',
                border: '1px solid rgba(0, 123, 255, 0.2)'
              }}
            />
          </div>
        </section>

        {/* 2. 🟦 Products Carousel (JUST BELOW HERO BOX) */}
        <section className="products-carousel-wrapper">
          <div className="section-header-row" style={{ justifyContent: 'flex-end', marginBottom: '0.8rem' }}>
            {/* <Link to={user ? "/home" : "/register"} className="view-all-link">
              View All Products ➔
            </Link> */}
            {/* by rajan - view me click krne se jaha prod listed hai waha(search.js) redirect */}
            <Link to="/search" className="view-all-link">
              View All Products ➔
            </Link>
          </div>

          {/* Horizontal Product Cards Carousel */}
          <div className="cards-scroll-row">
            {products.slice(0, 8).map((p) => (
              <div key={p._id} className="target-product-card">
                <div className="card-img-box">
                  <img
                    src={p.image}
                    alt={p.name}
                    referrerPolicy="no-referrer"
                  />
                </div>
                <div>
                  <h3 className="target-card-title">{p.name}</h3>
                  <p className="target-card-desc">High Accuracy Sensor & Robotics Module.</p>
                  <p className="target-card-price">₹{p.price}</p>
                </div>
                <button
                  className="target-view-btn"
                  onClick={() => handleProductClick(p._id)}
                >
                  View Details
                </button>
              </div>
            ))}
          </div>
        </section>

        {/* 2. 🛡️ 4 Feature Highlights Strip */}
        <section className="features-strip-grid">
          <div className="feature-strip-item">
            <div className="feature-icon-bubble" style={{ backgroundColor: '#E0F2FE', color: '#0284C7' }}>🛡️</div>
            <div className="feature-item-text">
              <h4>Automation Engineering</h4>
              <p>Smart solutions for a smarter tomorrow.</p>
            </div>
          </div>

          <div className="feature-strip-item">
            <div className="feature-icon-bubble" style={{ backgroundColor: '#F3E8FF', color: '#9333EA' }}>🛒</div>
            <div className="feature-item-text">
              <h4>E-Commerce Excellence</h4>
              <p>Quality products, trusted service.</p>
            </div>
          </div>

          <div className="feature-strip-item">
            <div className="feature-icon-bubble" style={{ backgroundColor: '#FEF3C7', color: '#D97706' }}>💡</div>
            <div className="feature-item-text">
              <h4>Innovation Hub</h4>
              <p>Next-gen tech for real-world impact.</p>
            </div>
          </div>

          <div className="feature-strip-item">
            <div className="feature-icon-bubble" style={{ backgroundColor: '#D1FAE5', color: '#059669' }}>🌐</div>
            <div className="feature-item-text">
              <h4>Global Support</h4>
              <p>Across countries, we're always with you.</p>
            </div>
          </div>
        </section>

        {/* 3. 🟦 Explore Our Products Carousel Section

        <section className="products-carousel-wrapper">
          <div className="section-header-row">
            <div className="section-title-mark">
              <div className="blue-mark"></div>
              <h2>Explore Our Products</h2>
            </div>
            <Link to={user ? "/home" : "/register"} className="view-all-link">
              View All Products ➔
            </Link>
          </div> */}
        {/* <section className="products-carousel-wrapper">
          <div className="section-header-row" style={{ justifyContent: 'flex-end', marginBottom: '0.8rem' }}>
            <Link to={user ? "/home" : "/register"} className="view-all-link">
              View All Products ➔
            </Link>
          </div> */}

        {/* Horizontal Product Cards Carousel */}
        {/* <div className="cards-scroll-row">
            {products.slice(0, 8).map((p) => (
              <div key={p._id} className="target-product-card">
                <div className="card-img-box">
                  <img 
                    src={p.image} 
                    alt={p.name} 
                    referrerPolicy="no-referrer"
                  />
                </div>
                <div>
                  <h3 className="target-card-title">{p.name}</h3>
                  <p className="target-card-desc">High Accuracy Sensor & Robotics Module.</p>
                  <p className="target-card-price">₹{p.price}</p>
                </div>
                <button 
                  className="target-view-btn"
                  onClick={() => handleProductClick(p._id)}
                >
                  🛒 View Details
                </button>
              </div>
            ))}
          </div>
        </section> */}

        {/* 4. 🤝 Trust Banner Strip */}
        <section className="trust-strip-bar">
          <div className="trust-item">
            <img
              src={logoImg}
              alt="SS Robotics Logo"
              style={{
                width: '36px',
                height: '36px',
                objectFit: 'cover',
                borderRadius: '8px'
              }}
            />
            <div className="trust-text">
              <h5>SS Robotics</h5>
              <p>Build. Buy. Believe.</p>
            </div>
          </div>
          <div className="trust-item">
            <span className="trust-icon">🚚</span>
            <div className="trust-text">
              <h5>Fast & Reliable Shipping</h5>
              <p>Across multiple countries.</p>
            </div>
          </div>
          <div className="trust-item">
            <span className="trust-icon">🛡️</span>
            <div className="trust-text">
              <h5>Secure Payments</h5>
              <p>Multiple payment options.</p>
            </div>
          </div>
          <div className="trust-item">
            <span className="trust-icon">🎧</span>
            <div className="trust-text">
              <h5>24/7 Customer Support</h5>
              <p>We're here to help.</p>
            </div>
          </div>
        </section>

      </div>

      {/* 5. 🔒 Register Required Modal */}
      {showModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          display: 'flex', justifyContent: 'center', alignItems: 'center',
          zIndex: 3000, backdropFilter: 'blur(4px)'
        }}>
          <div style={{
            backgroundColor: darkMode ? '#1E293B' : '#FFFFFF',
            color: darkMode ? '#FFFFFF' : '#0F172A',
            padding: '2.2rem',
            borderRadius: '20px',
            maxWidth: '380px',
            width: '85%',
            textAlign: 'center',
            boxShadow: '0 10px 30px rgba(0, 123, 255, 0.25)',
            border: '2px solid #007BFF'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>🔐</div>
            <h3 style={{ color: '#007BFF', marginBottom: '0.4rem', fontSize: '1.4rem' }}>Registration Required</h3>
            <p style={{ opacity: 0.85, marginBottom: '1.6rem', fontSize: '0.9rem', lineHeight: '1.4' }}>
              Product details dekhne aur order karne ke liye pehle account register karein!
            </p>
            <div style={{ display: 'flex', gap: '0.8rem', justifyContent: 'center' }}>
              <button
                onClick={() => navigate('/register')}
                className="target-view-btn"
                style={{ width: 'auto', padding: '0.65rem 1.4rem' }}
              >
                Register Now
              </button>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  backgroundColor: 'transparent',
                  color: 'inherit',
                  border: '1px solid currentColor',
                  padding: '0.65rem 1.2rem',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  fontWeight: '600'
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}